import { FC } from "react";

export const ClickAndMousewheel: FC = () => {
  return (
      <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={28}
    fill="none"
  >
    <path
      stroke="#F6F7FD"
      strokeLinecap="round"
      strokeWidth={2.1}
      d="M4.667 11.666v4.667A9.333 9.333 0 0 0 14 25.666a9.333 9.333 0 0 0 9.333-9.333V10.5a8.167 8.167 0 0 0-8.166-8.167H14a9.333 9.333 0 0 0-9.334 9.333Z"
    />
    <path
      stroke="#F6F7FD"
      strokeLinecap="round"
      strokeWidth={2.1}
      d="M14 2.333V9.8a.7.7 0 0 0 .7.7h8.633"
    />
    <path
      fill="#fff"
      d="M26.962 15.038V13.47h2.184v-2.184h1.708v2.184h2.184v1.568h-2.184v2.184h-1.708v-2.184h-2.184Z"
    />
    <path
      fill="#F6F7FD"
      d="m46 5.833.618-.619a.875.875 0 0 0-1.237 0l.619.619Zm0 9.333-.619.619a.875.875 0 0 0 1.237 0L46 15.166Zm-2.952-7.618a.875.875 0 0 0 1.237 1.237l-1.237-1.237Zm4.666 1.237a.875.875 0 1 0 1.238-1.237l-1.237 1.237Zm-3.429 3.43a.875.875 0 1 0-1.237 1.237l1.237-1.238Zm4.667 1.237a.875.875 0 1 0-1.237-1.238l1.237 1.238Zm-13.16-1.786v4.667h1.75v-4.667h-1.75Zm20.416 4.667v-4.667h-1.75v4.667h1.75Zm-11.083-10.5v9.333h1.75V5.833h-1.75Zm.256-.619-2.333 2.334 1.237 1.237 2.334-2.333-1.238-1.238Zm0 1.238 2.334 2.333 1.237-1.237-2.334-2.334-1.237 1.238Zm1.237 8.096-2.333-2.334-1.237 1.238 2.333 2.333 1.237-1.237Zm0 1.237 2.334-2.333-1.237-1.238-2.334 2.334 1.237 1.237Zm9.59-4.119c0-5.638-4.57-10.208-10.208-10.208v1.75a8.458 8.458 0 0 1 8.458 8.458h1.75ZM46 26.541c5.638 0 10.208-4.57 10.208-10.208h-1.75A8.458 8.458 0 0 1 46 24.791v1.75ZM35.79 16.333c0 5.638 4.57 10.208 10.209 10.208v-1.75a8.458 8.458 0 0 1-8.459-8.458h-1.75Zm1.75-4.667A8.458 8.458 0 0 1 46 3.208v-1.75c-5.638 0-10.209 4.57-10.209 10.208h1.75Z"
    />
  </svg>
  );
};